import { type FC, useContext } from 'react';
import { CartServerVarsContext } from '../CartServerVarsContext';

import classnames from 'classnames';
import dibsCss from 'dibs-css';
import cartItemStyles from '../CartItemCard/CartItemCard.scss';
import sharedStyles from '../sharedStyles.scss';
import shimmerStyles from './CartItemCardShimmer.scss';

export const CartItemCardShimmer: FC = () => {
    const { isMobile } = useContext(CartServerVarsContext);

    const containerClass = classnames(cartItemStyles.container, dibsCss.relative, {
        [dibsCss.h250px]: !isMobile,
        [dibsCss.borderDolphin]: !isMobile,
        [dibsCss.roundedXxsmall]: !isMobile,
        [dibsCss.border]: !isMobile,
        [dibsCss.borderSolid]: !isMobile,
        [dibsCss.pMedium]: !isMobile,
        [dibsCss.pyMedium]: isMobile,
        [dibsCss.mbSmall]: !isMobile,
    });

    const imageClass = classnames(
        cartItemStyles.image,
        sharedStyles.cartImageWrapper,
        dibsCss.flex,
        dibsCss.mrMedium,
        shimmerStyles.shimmer,
        {
            [sharedStyles.isMobile]: isMobile,
            [dibsCss.mrSmall]: isMobile,
            [dibsCss.selfStart]: isMobile,
        }
    );

    const titleClass = classnames(cartItemStyles.title, dibsCss.sassyFontBody);
    const priceClass = classnames(cartItemStyles.price, {
        [dibsCss.mlSmall]: !isMobile,
        [dibsCss.mtXsmall]: isMobile,
    });
    const optionsClass = classnames(cartItemStyles.options, dibsCss.mtXsmall, {
        [dibsCss.flex]: isMobile,
        [dibsCss.mtSmall]: isMobile,
    });
    const footerClass = classnames(cartItemStyles.footer, dibsCss.mtSmall, {
        [dibsCss.mtSmall]: !isMobile,
        [dibsCss.mtXsmall]: isMobile,
    });
    const buyButtonsClass = classnames(
        cartItemStyles.buyButtons,
        dibsCss.flex,
        dibsCss.justifyEnd,
        { [dibsCss.mtSmall]: !isMobile, [dibsCss.mtXsmall]: isMobile }
    );
    const rowClass = classnames(shimmerStyles.row);
    const shortRowClass = classnames(shimmerStyles.row, dibsCss.w80, dibsCss.mtXxsmall);
    const ctaClass = classnames(shimmerStyles.row, dibsCss.w40, {
        [dibsCss.mtSmall]: !isMobile,
    });
    const buyButtonsRowClass = classnames({
        [dibsCss.mtXsmall]: isMobile,
        [dibsCss.w80]: !isMobile,
        [dibsCss.w33]: isMobile,
        [shimmerStyles.higherRow]: isMobile,
        [shimmerStyles.row]: !isMobile,
    });
    const footerRowClass = classnames(shimmerStyles.row, { [dibsCss.w80]: isMobile });

    return (
        <div className={containerClass}>
            <div className={imageClass} />
            <div className={titleClass}>
                <div className={rowClass} />
                <div className={shortRowClass} />
            </div>
            <div className={priceClass} />
            <div className={optionsClass}>
                <div className={ctaClass} />
            </div>
            <div className={footerClass}>
                <div className={footerRowClass} />
            </div>
            <div className={buyButtonsClass}>
                <div className={buyButtonsRowClass} />
            </div>
        </div>
    );
};
